import { Stack, Text, ThemeOverride } from "@certn/cascadia";
import { useTranslation } from "react-i18next";
import { Avatar, Card, Divider } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { useAuth } from "@certn/auth";
import { parseName } from "@certn/utils";
import { useBrandingContext } from "../BrandingContext";
import { NavLogo } from "@certn/cascadia-react/components/navigation/navigation-top/NavLogo";
import { darkColors, lightColors } from "@certn/cascadia-tokens";

export function DesktopMenu() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const { processedBrandingAssets } = useBrandingContext();

  return (
    <Stack orientation="vertical" gap="space-5" className={styles.container}>
      <Text style="global/heading-medium">{t("Sample")}</Text>
      <Stack orientation="vertical" gap="space-5">
        <Text style="global/heading-medium" className={styles.heading}>
          {t("Light mode")}
        </Text>
        <ThemeOverride theme="light">
          <Card className={styles.lightMode}>
            <Stack orientation="vertical" gap="space-0">
              <Stack
                justify="space-between"
                orientation="horizontal"
                className={styles.mode}
              >
                <div className={styles.logoContainer}>
                  <NavLogo
                    type="full"
                    logoUrl={processedBrandingAssets?.org_logo_url}
                    darkLogoUrl={
                      processedBrandingAssets?.org_logo_url_dark_mode
                    }
                  />
                </div>
                <Avatar name={parseName(user?.name)} size="medium" />
              </Stack>
              <Divider />
              <Stack className={styles.empty} />
            </Stack>
          </Card>
        </ThemeOverride>
      </Stack>
      <Stack orientation="vertical" gap="space-5">
        <Text style="global/heading-medium" className={styles.heading}>
          {t("Dark mode")}
        </Text>
        <ThemeOverride theme="dark">
          <Card className={styles.darkMode}>
            <Stack orientation="vertical" gap="space-0">
              <Stack
                justify="space-between"
                orientation="horizontal"
                className={styles.mode}
              >
                <div className={styles.logoContainer}>
                  <NavLogo
                    type="full"
                    logoUrl={processedBrandingAssets?.org_logo_url}
                    darkLogoUrl={
                      processedBrandingAssets?.org_logo_url_dark_mode
                    }
                  />
                </div>
                <Avatar name={parseName(user?.name)} size="medium" />
              </Stack>
              <Divider />
              <Stack className={styles.empty} />
            </Stack>
          </Card>
        </ThemeOverride>
      </Stack>
    </Stack>
  );
}

const styles = {
  logo: css({
    background: "transparent",
    border: "none",
    outline: "none",
    height: "30px",
  }),
  logoImg: css({
    display: "block",
    height: "100%",
    width: "auto",
  }),
  container: css({
    paddingBottom: "var(--space-5)",
    paddingLeft: "var(--space-3)",
    paddingRight: "var(--space-3)",
  }),
  mode: css({
    paddingTop: "var(--space-4)",
    paddingBottom: "var(--space-4)",
    paddingLeft: "var(--space-8)",
    paddingRight: "var(--space-8)",
  }),
  darkMode: css({
    backgroundColor: `${darkColors["surface-base"]} !important`,
  }),
  lightMode: css({
    backgroundColor: `${lightColors["surface-base"]} !important`,
  }),
  heading: css({
    paddingLeft: "var(--space-7)",
    paddingRight: "var(--space-7)",
  }),
  empty: css({
    height: "50px",
  }),
  logoContainer: css({
    width: "fit-content",
    maxWidth: "200px",
    "& img, & svg": {
      width: "auto !important",
      maxWidth: "200px",
      height: "30px",
    },
  }),
};
